/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
console.log('custom js injected');

(function() {
  var badLocationText = /from\s+undefined/gi;
  var fallbackLocationText = 'near Milwaukee';

  function rewriteTextNode(node) {
    if (!node || !node.nodeValue || !badLocationText.test(node.nodeValue)) {
      return;
    }

    node.nodeValue = node.nodeValue.replace(badLocationText, fallbackLocationText);
  }

  function fixSalesPopLocation(root) {
    if (!root) {
      return;
    }

    if (root.nodeType === Node.TEXT_NODE) {
      rewriteTextNode(root);
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) {
      return;
    }

    if (root.childNodes && root.childNodes.length) {
      root.childNodes.forEach(function(child) {
        fixSalesPopLocation(child);
      });
    }
  }

  fixSalesPopLocation(document.body);

  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'characterData') {
        rewriteTextNode(mutation.target);
      }

      mutation.addedNodes.forEach(function(node) {
        fixSalesPopLocation(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    characterData: true,
    subtree: true
  });
})();
